// components/Sidebar.jsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSun, faMoon, faUsers, faDice, faSlidersH, faSignOutAlt, faCog, faCrown, faUserShield
} from '@fortawesome/free-solid-svg-icons';

function Sidebar({
  roomId, users, hostId, admins, userId,
  activeTab, setActiveTab, canManageChallenges, leaveRoom,
  isDarkMode, setIsDarkMode
}) {
  return (
    <aside className="w-full md:w-64 bg-surface border-r border-border p-4 flex flex-col shadow-md md:h-screen">
      <div className="mb-6 flex items-center justify-between">
        <h2 className="text-xl font-bold text-primary">Raum: {roomId}</h2>
        {/* Dark Mode Toggle Button */}
        <button
          onClick={() => setIsDarkMode(!isDarkMode)}
          className="p-2 rounded-full text-text hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50"
          title="Dark Mode umschalten"
        >
          <FontAwesomeIcon icon={isDarkMode ? faSun : faMoon} size="lg" />
        </button>
      </div>

      {/* Navigation Tabs */}
      <nav className="flex flex-col gap-2 mb-6">
        <button
          className={`py-2 px-3 rounded-lg text-left font-semibold ${activeTab === 'game' ? 'bg-primary text-white shadow-md' : 'text-text-light hover:bg-gray-100 dark:hover:bg-gray-700'}`}
          onClick={() => setActiveTab('game')}
        >
          <FontAwesomeIcon icon={faDice} className="mr-2" /> Spiel
        </button>
        {canManageChallenges && (
          <button
            className={`py-2 px-3 rounded-lg text-left font-semibold ${activeTab === 'challenge-admin' ? 'bg-primary text-white shadow-md' : 'text-text-light hover:bg-gray-100 dark:hover:bg-gray-700'}`}
            onClick={() => setActiveTab('challenge-admin')}
          >
            <FontAwesomeIcon icon={faCog} className="mr-2" /> Herausforderungen
          </button>
        )}
        {(hostId === userId || admins.includes(userId)) && (
          <button
            className={`py-2 px-3 rounded-lg text-left font-semibold ${activeTab === 'settings' ? 'bg-primary text-white shadow-md' : 'text-text-light hover:bg-gray-100 dark:hover:bg-gray-700'}`}
            onClick={() => setActiveTab('settings')}
          >
            <FontAwesomeIcon icon={faSlidersH} className="mr-2" /> Einstellungen
          </button>
        )}
      </nav>

      {/* User List in Sidebar */}
      <div className="mb-6 flex-grow overflow-y-auto">
        <h3 className="text-lg font-bold mb-3 text-text">
          <FontAwesomeIcon icon={faUsers} className="mr-2 text-primary" /> Spieler
        </h3>
        <ul className="space-y-2">
          {users.map((u) => (
            <li key={u.id} className="flex items-center gap-2 text-text-light">
              <span className={`w-3 h-3 rounded-full ${u.connected ? 'bg-green-500' : 'bg-red-500'}`}></span>
              <span>{u.name}</span>
              {u.id === hostId && <FontAwesomeIcon icon={faCrown} className="text-yellow-500 ml-1" title="Host" />}
              {admins.includes(u.id) && u.id !== hostId && <FontAwesomeIcon icon={faUserShield} className="text-blue-500 ml-1" title="Admin" />}
              {u.id === userId && <span className="text-sm text-gray-500">(Du)</span>}
            </li>
          ))}
        </ul>
      </div>

      {/* Leave Room Button */}
      <button
        onClick={leaveRoom}
        className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-75 transition-colors duration-200"
      >
        <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" /> Raum verlassen
      </button>
    </aside>
  );
}

export default Sidebar;